<template>
  <div class="mobile">
    <MobileHeader :tab-select="tabSelect"/>
    <el-dialog v-model="dialogVisible" width="640">
      三色球 {{ selectedKajgg.qih }} 回放 開獎時間：{{
        selectedKajgg.kaijrq
      }}
      21:30:00 開獎號碼：
      <div class="num">
        <span class="ball"
          ><span class="balls red">{{ kaijhm[0] }}</span></span
        >
        <span class="ball"
          ><span class="balls green">{{ kaijhm[1] }}</span></span
        >
        <span class="ball"
          ><span class="balls blue">{{ kaijhm[2] }}</span></span
        >
        <span class="ball"
          ><span class="balls green">{{ kaijhm[3] }}</span></span
        >
        <span class="ball"
          ><span class="balls blue">{{ kaijhm[4] }}</span></span
        >
        <span class="ball"
          ><span class="balls red">{{ kaijhm[5] }}</span></span
        >
        <span
          class="ball font-red"
          style="font-size: 20px; padding: 0px 0px 0px 5px"
          >+</span
        >
        <span class="ball"
          ><span class="balls blue">{{ kaijhm[6] }}</span></span
        >

        <div class="loading" :style="showDlgLoading">loading...</div>

        <div class="animat">
				<div class="animate_min">
					<div class="btn_box">
						<ul>
							<li>
								<a id="try" href="#"></a>
							</li>
							<li id="sound" class="on" style="display:none">
								<a href="#"></a>
							</li>
						</ul>
					</div>
				</div>
				<div class="animate_date">
					<b id="data_b">{{selectedKajgg.kaijrq}}</b> <span>第</span><b id="issue_b">{{selectedKajgg.qih}}</b><span>期</span>
				</div>
				<div class="view_box status" style="display: initial; background-image: url('../assets/status.gif');"></div>
				<div class="view_box each" style="display: block; background-image: url('../assets/each.gif');"></div>
				<div class="view_box play" id="die" style="background-image: url('../assets/empt.png') !important;">
					<div class="ball">
						<span class="green rotate" style="transform: rotate(-168deg); top: 0.2rem; left: 1.45rem; display: inline;"></span>
						<span class="red rotate" style="transform: rotate(-160deg); top: 0.2rem; left: 1.45rem; display: inline;"></span>
						<span class="red rotate" style="transform: rotate(-152deg); top: 0.2rem; left: 1.45rem; display: inline;"></span>
						<span style="transform: rotate(0deg); top: 2.6rem; left: 1.45rem; display: none;"></span>
						<span style="transform: rotate(0deg); top: 2.6rem; left: 1.45rem; display: none;"></span>
						<span style="transform: rotate(0deg); top: 2.6rem; left: 1.45rem; display: none;"></span>
						<span style="transform: rotate(0deg); top: 2.6rem; left: 1.45rem; display: none;"></span>
					</div>
					<div class="crust">
						<div class="number_box">
							<div class="number">
								<ul><li class="green">{{kaijhm[0]}}</li><li class="red">{{kaijhm[1]}}</li><li class="red">{{kaijhm[2]}}</li><li class="red">{{kaijhm[3]}}</li><li class="blue">{{kaijhm[4]}}</li><li class="red">{{kaijhm[5]}}</li><li class="blue lastLi">{{kaijhm[6]}}</li></ul>
							</div>
						</div>
					</div>
				</div>
			</div>

      </div>
    </el-dialog>
    <div class="main-con clearfix">
      <div class="clearfix pad10">
        <div class="notice pad10 auto">
          <p class="title"> 即時開獎驗證： </p>
          <p class="con">
            開獎現場直播，與中央電視台1套同步，開獎過程100%公開公正！
          </p>
        </div>
      </div>
      <div class="clear"></div>
      <div class="live">
        <div class="liveSon">
          <div class="font-con">
            <span>
              三色球攪珠直播時間為周一三五每晚<span class="phone">
                21:30 </span
              >(北京時間)，敬請查看。
            </span>
          </div>
        </div>
      </div>
      <div class="clear h20"></div>
      <div
        class="title-line border pad10"
        style="border-bottom: 0px !important">
        <span class="lotteryName">開獎視頻 </span>
        <div class="clear h10"></div>
        <button class="six choice" style="border-radius:5px;">今年</button>
      </div>

      <div class="border clearfix">
        <div class="video-notice">開獎視頻回放，僅保留當年部分供用戶查看</div>
        <div class="clear"></div>
        <ul class="clearfix">
          <li
            class="fxl pos-rel repeat"
            v-for="(item, index) in kaijggList"
            :key="index"
          >
            <img src="../assets/repeat.png" alt="" class="livebg" />
            <img
              @click="dialogOpen(item)"
              src="data:image/png;base64,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"
              class="play pos-abs video-detail"

            />
            <span class="font"
              >三色球 <br/>第<span class="font-red"> {{ item.qih }}</span>
              期</span
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="clear h20"></div>
    <MobileFooter :tab-select="tabSelect"/>
  </div>
</template>

<script>
import MobileHeader from "./MobileHeader";
import MobileFooter from "./MobileFooter";
import axios from "axios";

export default {
  components: {
    MobileHeader,
    MobileFooter,
  },

  data() {
    return {
      showDlgLoading: "display: block;",
      kaijhm: [],
      selectedKajgg: {},
      dialogVisible: false,
      kaijggList: [],
      lunbtList: [],
      daohcdList: [],
      tabSelect: 2,
    };
  },

  // 注入全局变量
  inject: ["imageUrl", "serviceUrl"],

  mounted() {
    let that = this;

    axios
      .get(that.serviceUrl + "/kaijgg/ayKaijgg/list", {
        params: {
          column: "qih",
          order: "desc",
          pageNo: 1,
          pageSize: 365,
        },
      })
      .then((resp) => {
        that.kaijggList = resp.data.result.records;
      })
      .catch((error) => {
        console.log(error);
      });
  },

  methods: {
    dialogOpen(item) {
      // console.log(item)

      // let that = this
      // that.showDlgLoading = "display: block;"

      // that.dialogVisible = true;
      // that.selectedKajgg = item;

      // that.kaijhm = that.selectedKajgg.kaijhm.split(",");

      // setTimeout(() => {
      //   // 在这里编写要延迟执行的代码
      //   that.showDlgLoading = "display: none;"
      // }, 1500);

      
    },
  },
};
</script>

<style scoped lang="less">
.animat {
  background: #fff url("../assets/bg.fw.png") 0 0 no-repeat;
  background-size: 100%;
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  background: #000000;
  width: 100%;
  height: 100%;
  z-index: 999;
  text-align: center;
  box-sizing: border-box;
  padding-top: 25%;
  font-size: 23px;
  color: #fff;
}

.live {
  position: relative;
  height: 368px;
  width:100%;
  padding: 0;
  overflow: hidden;
  background-color: #000;
}

.live .maintain {
  display: inline-block;
  height: 36px;
  line-height: 36px;
  font-size: 20px;
  background-color: #d80011;
  padding: 0 20px;
  color: #fff;
  border-radius: 18px;
  position: absolute;
  top: 0;
  left: 265px;
  z-index: 1;
}

.live .full {
  width: 20px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 1;
  cursor: pointer;
}

.live .liveSon {
  width: 100%;
  height: 100%;
}

.live .liveSon .cover {
  width: 640px;
  height: 368px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 4;
  background-color: #000;
}

.live .liveSon .play {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  z-index: 6;
}

.font-con {
  line-height: 36px;
  font-size: 18px;
  color: #fff;
  padding:30px;
  height:100%;
  display: flex;
  text-align: center;
  flex-direction: center;
  align-items: center;

  .left {
    color: #a68452;
  }

  .phone {
    color: #d80011;
  }
}

.title-line .lotteryName {
  font-size: 16px;
  color: #2c2c2c;
  font-weight: 600;
  margin-right: 20px;
  display: inline-block;
  width: 186px;
}
.title-line .desc {
  display: inline-block;
  height: 25px;
  width: 300px;
  text-align: center;
  line-height: 25px;
  font-size: 14px;
  color: #d80011;
  background-color: #fdf7e8;
  margin-right: 218px;
}
.title-line .search {
  display: inline-block;
  height: 36px;
  line-height: 36px;
  border: 1px solid #c6c6c6;
  border-radius: 18px;
  padding: 0 6px;
  position: relative;
  top: 1px;
  left: 4px;
}
.title-line .search input {
  outline: none;
  border: none;
  height: 24px;
  line-height: 24px;
  width: 95px;
  color: #515151;
  padding-left: 4px;
  position: relative;
  top: -1px;
}
.title-line .search img {
  width: 17px;
  position: relative;
  top: 3px;
  right: 6px;
}
.title-line button {
  color: #646464;
  outline: none;
  border: none;
  height: 30px;
  line-height: 30px;
  text-align: center;
  padding: 0 10px;
  border-radius: 4px;
  background-color: #fff;
  font-size: 15px;
  cursor: pointer;
}
.title-line button:last-of-type {
  margin-right: 60px;
}
.title-line .choice {
  background-color: #d80011;
  color: #fff;
  border-radius: 18px;
}

.fullLive {
  width: 100vw;
  height: 100vh;
  margin: 0;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0;
  overflow: hidden;
  background-color: #000;
  z-index: 5;
}
.fullLive .fullLiveSon {
  width: 640px;
  height: 368px;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.fullLive .fullLiveSon .play {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  z-index: 6;
}
.fullLive .fullLiveSon .esc {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  width: 250px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  top: 20px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 6;
}
.fullLive .fullLiveSon .bigcover {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 4;
  background-color: #000;
}
.fullLive .quit {
  width: 20px;
  position: absolute;
  bottom: 10px;
  right: 28px;
  z-index: 11;
  cursor: pointer;
}

.loading {
  width: 640px;
  height: 368px;
  font-size: 30px;
  z-index: 20;
  background-color: #000;
}

.repeat {
  width: calc(50% - 20px);
  margin: 10px;
  text-align: center;
  .livebg {
    width: 100%;
  }
  .play {
    cursor: pointer;
    z-index: 10;
    left: 50%;
    top: 50%;
    width:60px;
    height:60px;
    margin: -50px 0px 0px -20px;
  }
  .font {
    line-height: 20px;
    text-align: center;
    width: 100%;
  }
}
.video-notice{
  margin: 10px;
  padding: 0 10px;
  background-color: #fadce9;
  font-size: 12px;
  line-height: 25px;
  height: 25px;
  color: #c30055
}
</style>
